import { render } from "./RemoteAttendanceApprovals.vue?vue&type=template&id=ab45efca&scoped=true"
import script from "./RemoteAttendanceApprovals.vue?vue&type=script&lang=js"
export * from "./RemoteAttendanceApprovals.vue?vue&type=script&lang=js"

import "./RemoteAttendanceApprovals.vue?vue&type=style&index=0&id=ab45efca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab45efca"]])

export default __exports__